import { render, staticRenderFns } from "./RouteListComponent.vue?vue&type=template&id=ed63b828&scoped=true&lang=pug&"
import script from "./RouteListComponent.vue?vue&type=script&lang=js&"
export * from "./RouteListComponent.vue?vue&type=script&lang=js&"
import style0 from "./RouteListComponent.vue?vue&type=style&index=0&id=ed63b828&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed63b828",
  null
  
)

export default component.exports